
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"oeamtc-icon__car","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.24 4.88a1.85 1.85 0 011.85-1.13h3.82a1.85 1.85 0 011.85 1.13l.43 1.5a.25.25 0 01-.17.31h-.12A24.51 24.51 0 008 6.5a24.51 24.51 0 00-3.9.2.27.27 0 01-.3-.2.49.49 0 010-.12zm10.76 4a2.28 2.28 0 00-1.37-2.1L13 4.55a3.12 3.12 0 00-3.09-2H6.09a3.11 3.11 0 00-3.09 2l-.63 2.23A2.28 2.28 0 001 8.88V13a1 1 0 002 0v-1h10v1a1 1 0 002 0zM13 10a.68.68 0 010-1.35.64.64 0 01.59.33.66.66 0 010 .69.64.64 0 01-.59.33zM3 10a.68.68 0 010-1.32.64.64 0 01.57.32.66.66 0 010 .69A.64.64 0 013 10zm7.52 0h-5A.5.5 0 015 9.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5.5.5 0 01-.5.5z"}})])
          )
        }
      }
    